<template>
    <div class="hideFrame" :id="'frame'+id">
        <iframe :src="'https://player.vimeo.com/video/'+url" width="100%" height="200" frameborder="0" allow="autoplay; fullscreen" allowfullscreen class="video"></iframe>
    </div>

</template>
      
    <script>
      // register the grid component
      export default {
        name: "Frame",
        props: {
          url: String,
          id: [String, Number],
          show: {
                type: Boolean,
                default: false
                },

        },
        data() {
          return {
          };
        },
        computed: {
        },
        methods: {
        },
      };
    </script>

    <style >
      .hideFrame {
    visibility: hidden;
    opacity: 0;
    transform: translateY(-10px);
    transition: visibility 1s, opacity 0.5s, transform 1s linear;
  }
  .activeFrame {
    visibility: visible;
    opacity: 1;
    transform: translateY(10px);
    transition: visibility 1s, opacity 0.5s, transform 1s linear;
  }
    </style>




// WEBPACK FOOTER //
// src/components/Frame.vue